var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"grid grid--container"},[_c('p',{staticClass:"footer__copyright"},[_vm._v("\n      Copyright "+_vm._s(new Date().getFullYear())+" Campsite.bio\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }